import { render, staticRenderFns } from "./DocxViewer.vue?vue&type=template&id=09227821&scoped=true"
import script from "./DocxViewer.vue?vue&type=script&lang=js"
export * from "./DocxViewer.vue?vue&type=script&lang=js"
import style0 from "./DocxViewer.vue?vue&type=style&index=0&id=09227821&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09227821",
  null
  
)

export default component.exports